"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignUsersToOrganization = assignUsersToOrganization;
exports.createOrganization = createOrganization;
exports.getAllOrganizations = getAllOrganizations;
exports.getOrganizationById = getOrganizationById;
exports.updateOrganizationById = updateOrganizationById;
exports.uploadFile = uploadFile;
var _request = _interopRequireDefault(require("@/utils/request"));
function getAllOrganizations(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };

  // 配置请求参数
  const config = {
    url: '/v1/organizations',
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'get',
    headers
  };

  // 当query存在且非空时，才添加params配置
  if (query && Object.keys(query).length > 0) {
    config.params = query;
  }
  return (0, _request.default)(config);
}
function getOrganizationById(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/v1/organizations/' + id,
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'get',
    headers
  });
}
function createOrganization(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/v1/organizations',
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'post',
    headers,
    data
  });
}
function updateOrganizationById(token, id, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: `/v1/organizations/${id}`,
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'put',
    headers,
    data
  });
}
function uploadFile(token, id, fileData) {
  const headers = {
    'Authorization': 'Bearer ' + token,
    'Content-Type': 'multipart/form-data'
  };
  return (0, _request.default)({
    url: `/v1/organizations/${id}/logo`,
    baseURL: process.env.VUE_APP_ORG_BASE_API,
    method: 'post',
    data: fileData,
    headers
  });
}
function assignUsersToOrganization(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: `/users/assign-to-organization`,
    baseURL: process.env.VUE_APP_BASE_AUTH_API,
    method: 'post',
    headers,
    data
  });
}